import { render } from "./IntroText.vue?vue&type=template&id=41071d80&scoped=true"
const script = {}

import "./IntroText.vue?vue&type=style&index=0&id=41071d80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41071d80"]])

export default __exports__